import { Directive, TemplateRef } from '@angular/core';

/**
 * Structural directive for projecting custom content (e.g. icon, HTML) beside the dropdown label.
 * Use on ng-template inside nxt-dropdown. When not provided, the label suffix is empty.
 */
@Directive({
  selector: '[nxtDropdownLabelSuffix]'
})
export class NxtDropdownLabelSuffixDirective {
  constructor(public readonly templateRef: TemplateRef<unknown>) {}
}
